import { createContext, useContext } from 'react';
import type { ForcedReason } from '@/types/tournament.model';

/** Opens the slot detail for a forced match. */
export type SlotOccupancyOpener = (
  matchId: string,
  reason: ForcedReason,
) => void;

/**
 * Null outside the fixture view. The badge is rendered from several places (group cards, bracket,
 * knockout list) and only the fixture section knows which tournament to ask about, so the opener
 * travels by context instead of through four prop chains. Without a provider the badge stays a
 * plain label.
 */
export const SlotOccupancyContext = createContext<SlotOccupancyOpener | null>(
  null,
);

export const useSlotOccupancyOpener = () => useContext(SlotOccupancyContext);
